// src/features/clinical/components/common/DoctorNotes.jsx
import React from 'react';
import { FaNotesMedical } from 'react-icons/fa';

const DoctorNotes = ({ notes, onNotesChange }) => {
  const [localNotes, setLocalNotes] = React.useState(notes);

  const handleChange = (e) => {
    setLocalNotes(e.target.value);
    onNotesChange(e.target.value);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <h3 className="text-lg font-medium text-gray-900 mb-3 flex items-center">
        <FaNotesMedical className="mr-2 text-blue-600" />
        Doctor's Notes & Remarks
      </h3>
      
      <div className="space-y-4">
        <textarea
          rows="4"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={localNotes}
          onChange={handleChange}
          placeholder="Enter clinical notes, observations, and remarks..."
        />
        
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Diagnosis
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Primary diagnosis"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              ICD-10 Code
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="e.g., J02.9"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Patient Education & Instructions
          </label>
          <textarea
            rows="2"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Instructions for patient..."
          />
        </div>
      </div>
    </div>
  );
};

export default DoctorNotes;